import React, { useMemo, useCallback } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule, RuleObject } from 'antd/lib/form';
import { StoreValue } from 'antd/lib/form/interface';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeSerialNumber: (value: string) => void;
}

export const SerialNumberField: React.FC<IProps> = React.memo(({ changeSerialNumber }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterSerialNumber') },
			() => ({
				validator(_: RuleObject, value: StoreValue) {
					if (value.length <= 64) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('valueMustContainNoMore', { value: 64 })));
				},
			}),
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
			changeSerialNumber(valueWithoutSpaces);
			return valueWithoutSpaces;
		},
		[changeSerialNumber],
	);

	return (
		<FormInput
			testId="SerialNumberField"
			name="serialNumber"
			label="serialNumberLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
